/** @jsxImportSource solid-js */

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import { createMemo } from 'solid-js';
import ConnectSnackbar, {
  ConnectSnackbarProps,
  ISnackBarMessage,
} from './ConnectSnackbar';
import { ICustomElement, noShadowDOM } from 'component-register';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-connect-snackbar': Partial<HTMLElement> &
        ConnectSnackbarProps &
        Partial<{ ref: ICustomElement }> & {
          message?: string; // Allow string serialization for web component
        };
    }
  }
}

export function defineSolidConnectSnackbar(): void {
  customElement(
    'tc-connect-snackbar',
    {
      // Include ALL component properties with default values
      // This is CRITICAL for proper property synchronization
      message: undefined as unknown as string | ISnackBarMessage | undefined,
      color: undefined as unknown as string | undefined,
    },
    (props) => {
      noShadowDOM();

      // Parse message reactively using createMemo
      const parsedMessage = createMemo(() => {
        if (!props.message) return undefined;

        if (typeof props.message === 'string') {
          try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const parsed = JSON.parse(props.message);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return parsed;
          } catch (error) {
            // If parsing fails, treat as simple text message
            return { text: props.message };
          }
        }

        return props.message;
      });

      // Use the reactive memo in the JSX
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      return <ConnectSnackbar message={parsedMessage()} color={props.color} />;
    }
  );
}
